import { render, staticRenderFns } from "./90.vue?vue&type=template&id=d58121e4&scoped=true&"
var script = {}
import style0 from "./90.vue?vue&type=style&index=0&id=d58121e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58121e4",
  null
  
)

export default component.exports